module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.5990/img/business-types/technology.png"